import NonEmptyHub from './non_empty_hub'
import { connect } from 'react-redux'
import { allCampaignsSelector } from 'redux/selectors/campaign'

const mapStateToProps = state => {
  return {
    campaigns: allCampaignsSelector(state),
    isMobile: state.device_info.isMobile,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NonEmptyHub)
